<template>
  <div class="customer">
    <gradientAnimation :skewY="0" :bottom="0" />
    <img src="@/assets/images/customer.png">
    <p>{{ $t('customer.scanTip') }}</p>
  </div>
</template>

<script>
  import gradientAnimation from '@/components/GradientAnimation'
  export default {
    name: "Customer",
    components: {
      gradientAnimation
    },
    data() {
      return {
      }
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>
  .customer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    & > div:first-child {
      z-index: -1;
    }
    & > img {
      width: 212px;
    }
    & > p {
      margin-top: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 27px;
    }
  }

  @media screen and (max-width: 768px) {
    .customer {
      min-height: 100vh;
      min-height: 100dvh;
      padding: 96px 24px 48px;
      justify-content: flex-start;

      & > img {
        width: 52vw;
        max-width: 212px;
      }

      & > p {
        margin-top: 24px;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
      }
    }
  }
</style>
